import React from "react";
import { Helmet } from "react-helmet";
import PageTitle from "../components/PageTitle";
import { Settings } from "../configuration/settings";
import Breadcrumbs from "../components/Breadcrumbs";

function DeliveryAndPayment() {
    return (
        <>
            <Helmet>
                <title>Доставка і оплата - {Settings.shopName} | Чоловічі джинси Levi’s</title>
                <meta name="description" content={`Умови доставки і оплати в інтернет-магазині ${Settings.shopName}. Швидка доставка по Україні, зручні способи оплати та гарантія оригінальних джинсів Levi’s.`} />
                <link rel="canonical" href={`${Settings.siteUrl}/delivery-and-payment/`} />
            </Helmet>
            <Breadcrumbs items={[ { text: "Доставка і оплата"} ]} />
            <PageTitle title="Доставка і оплата" />
            <div className="text-start">
                 <p>
                    Інтернет-магазин <strong>{Settings.shopName}</strong> пропонує зручні та 
                    прозорі умови <strong>доставки і оплати</strong> для 
                    покупців <strong>оригінальних чоловічих джинсів Levi’s</strong> по всій Україні.
                    Ми зробили процес замовлення простим, швидким і безпечним.
                </p>

                <h2 className="fs-5">Доставка по Україні</h2>
                <p>
                    В нашому магазині ви можете скористатися наступними способами доставки і оплати товару:
                </p>
                <ol>
                    <li>
                        <strong>OLX-доставка</strong>
                        <p>
                            Вартість доставки - за тарифами OLX і буде вказана при оформленні OLX-доставки.
                        </p>
                    </li>
                    <li>
                        <strong>Доставка службою "Нова Пошта"</strong>
                        <p>
                            Вартість доставки - за тарифами Нової Пошти.
                        </p>
                        <p>Доступні способи оплати:</p>
                            <ul>
                                    <li>
                                        <strong>Післяплата</strong>
                                        <p>
                                            Зверніть увагу: відправка післяплатою передбачає авансовий платіж у розмірі 200 грн.
                                        </p>
                                    </li>
                                    <li><strong>Передплата</strong></li>
                            </ul>
                        
                    </li>
                </ol>

                <p>
                    Термін доставки зазвичай становить <strong>1–3 робочі дні</strong> з моменту відправлення замовлення.
                    Після відправки ви отримуєте номер накладної для відстеження посилки.
                </p>

                <h2 className="fs-5">Перевірка товару при отриманні</h2>
                <p>
                    Ми рекомендуємо перевіряти замовлення безпосередньо при отриманні:
                </p>
                <ul>
                    <li>відповідність моделі</li>
                    <li>правильність розміру</li>
                    <li>зовнішній вигляд товару</li>
                </ul>
                <p>
                    Усі джинси Levi’s, представлені в магазині {Settings.shopName},
                    є <strong>100% оригінальними</strong> та перевіряються перед відправленням.
                </p>

                <h2 className="fs-5">Чому варто замовляти у {Settings.shopName}</h2>
                <ul>
                    <li>спеціалізація лише на <strong>чоловічих джинсах Levi’s</strong></li>
                    <li>інтернет-магазин працює з <strong>2020 року</strong></li>
                    <li>гарантія оригінальності товару</li>
                    <li>допомога з підбором розміру</li>
                    <li>швидка доставка по всій Україні</li>
                </ul>

                <h2 className="fs-5">Підсумок</h2>
                <p>
                    Інтернет-магазин <strong>{Settings.shopName}</strong> робить усе можливе,
                    щоб покупка <strong>чоловічих джинсів Levi’s онлайн</strong> була зручною, швидкою та безпечною.
                    Прозорі умови доставки і оплати - основа довіри наших клієнтів.
                </p>
            </div>
        </>
    );
}

export default DeliveryAndPayment;